import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "router/AppRouter";
import i18n, { Provider as I18nProvider } from "./locales";
import { SnackbarProvider } from "notistack";
import { Provider as StoreProvider } from "react-redux";
// import SpinnerRenderer from "containers/Renderer/SpinnerRenderer";
import Notification from "containers/Notification";
import { StylesProvider } from "@mui/styles";
import { store } from "store/store";

const App: React.FC = () => (
  <StylesProvider injectFirst>
    <I18nProvider i18n={i18n}>
      <StoreProvider store={store}>
        <BrowserRouter>
          <SnackbarProvider maxSnack={5}>
            {/* <SpinnerRenderer> */}
              <AppRouter />
              <Notification />
            {/* </SpinnerRenderer> */}
          </SnackbarProvider>
        </BrowserRouter>
      </StoreProvider>
    </I18nProvider>
  </StylesProvider>
);

export default App;